<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/OKslvl/tc-custom/9781035817566.jpg?1718183631605" alt="This image is the cover for the book Orcus Island"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Orcus Island
      </h1>
      <p class="bookDescription body article font2">
        <p>Five young adults reunite in a whirlwind of long-lost friendship and a haphazard mission to travel the world in secret. Will clinging to a years-old promise be enough for them as they are faced with the peculiar terrors presented by Orcus Island, or will they all fall apart into the memories of their pasts?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        A.D Gibson
      </h2>
      
      <p class="authorDescription body article">A.D Gibson is a writer from Northern Ireland. Before she started writing fantasy fiction, she completed a Bachelor of Business Administration at the University of Strathclyde in Glasgow. She now spends her time living and working in her native city of Belfast.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7ef0cee4